// extracted by mini-css-extract-plugin
module.exports = {"modal":"TradeModal_modal__1CLbC"};